import { type AnchorPlacement, type AnchorPoint } from './useAnchoredPosition'
import onboardingStep1Img from './assets/onboarding-step-1.png'
import onboardingCarouselImg from './assets/onboarding-carousel.png'

// Mirrors the TDS FeatureHighlightPulseProps['pulsePlacement'] union. The TDS
// package re-exports the component itself but not these supporting types, so
// duplicating the small string union locally is cheaper than reaching into
// the @instacart/tds deep import path (which the archlint forbids).
type PulsePlacement = 'top' | 'bottom' | 'left' | 'right'

// Each tour step pairs a DOM anchor with the popup placement, plus the
// pulse decoration that visually points back at the anchor. Selectors are
// `data-onboarding-tour-id` attributes added to the live nav components.
//
// Anchor data attrs are added in TdsNavigationBar.tsx and
// NavVersionSwitcherButton.tsx — keep them in sync if a key changes.
export type OnboardingStep = {
  selector: string
  placement: AnchorPlacement
  pulsePoint: AnchorPoint
  pulsePlacement: PulsePlacement
  titleKey: string
  descriptionKey: string
  imgSrc: string
  imgAltKey: string
}

export const ONBOARDING_STEPS: readonly OnboardingStep[] = [
  {
    selector: '[data-onboarding-tour-id="home"]',
    placement: 'right',
    pulsePoint: 'start',
    pulsePlacement: 'left',
    titleKey: 'navV3.onboarding.tour.step1.title',
    descriptionKey: 'navV3.onboarding.tour.step1.description',
    imgSrc: onboardingStep1Img,
    imgAltKey: 'navV3.onboarding.tour.step1.imgAlt',
  },
  {
    selector: '[data-onboarding-tour-id="sidebar-collapse"]',
    placement: 'right',
    pulsePoint: 'end',
    pulsePlacement: 'left',
    titleKey: 'navV3.onboarding.tour.step2.title',
    descriptionKey: 'navV3.onboarding.tour.step2.description',
    imgSrc: onboardingCarouselImg,
    imgAltKey: 'navV3.onboarding.tour.step2.imgAlt',
  },
  {
    selector: '[data-onboarding-tour-id="version-switcher"]',
    placement: 'bottom',
    pulsePoint: 'end',
    pulsePlacement: 'top',
    titleKey: 'navV3.onboarding.tour.step3.title',
    descriptionKey: 'navV3.onboarding.tour.step3.description',
    imgSrc: onboardingStep1Img,
    imgAltKey: 'navV3.onboarding.tour.step3.imgAlt',
  },
] as const
